export default __webpack_public_path__ + "static/media/snake_screenshot.18c8c30c.gif";